module.exports = __webpack_public_path__ + "sn.1569aca0.svg";